import { IBoxAccessibility } from './interfaces/box-accessibility.interface';

export class BoxAccessibilityChangeEvent {
    public constructor(
        public userId: string,
        public boxAccessibilities: IBoxAccessibility[]
    ) {}
}
